import { Link } from 'react-router-dom';
import type { ReactNode } from 'react';

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  action?: { to: string; label: string };
  align?: 'left' | 'center';
  children?: ReactNode;
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  action,
  align = 'left',
  children,
}: SectionHeadingProps) {
  return (
    <div
      className={`flex flex-col gap-4 md:flex-row md:items-end md:justify-between ${
        align === 'center' ? 'md:flex-col md:items-center md:text-center' : ''
      }`}
    >
      <div className={align === 'center' ? 'max-w-2xl' : 'max-w-2xl'}>
        {eyebrow && (
          <span className="mb-2 inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 font-label text-xs tracking-wide text-accent-900">
            <i className="ri-flashlight-line"></i>
            {eyebrow}
          </span>
        )}
        <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">{title}</h2>
        {description && (
          <p className="mt-3 font-body text-sm leading-relaxed text-foreground-600 md:text-base">{description}</p>
        )}
      </div>
      <div className="flex items-center gap-3">
        {children}
        {action && (
          <Link
            to={action.to}
            className="flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-3.5 py-2 font-label text-sm text-foreground-800 transition-colors hover:border-primary-300 hover:bg-primary-50 hover:text-primary-700"
          >
            {action.label}
            <i className="ri-arrow-right-line"></i>
          </Link>
        )}
      </div>
    </div>
  );
}